import { get, postj } from '@/utils/request';

export const invoiceList = (param) => get('users/invoice',param); // 发票列表
export const balanceList = (param) => get('users/balanceLog',param); // 财务明细
export const rechargeList = (param) => get('users/rechargeList',param); // 充值记录
export const remittanceData = (param) => get('users/remittanceData',param); // 汇款信息
export const recharge = (data) => postj('users/recharge',data); // 申请充值